import React, { useState, useEffect } from 'react'
import { connect } from 'dva'
import { injectIntl } from 'react-intl'
import { Divider, Breadcrumb, Spin } from 'antd'
import { Link } from 'react-router-dom'
import ReactMarkdown from 'react-markdown'
import Header from '@/components/Header'
// import HeaderMobile from '@/components/HeaderMobile'
import Footer from '@/components/Footer'
import styles from './detail.module.less'
import useLang from '../../../utils/lang.ts'
import { getQueryParams, textToUrl } from '../../../utils'

function Detail(props) {
  const { intl, dispatch, state, loading } = props
  const id = getQueryParams('id')
  const [lang] = useLang()
  const [enStyle, setEnStyle] = useState(lang === 'en')
  useEffect(() => {
    dispatch({ type: 'secureModule/getDetail', payload: { id, lang } })
  }, [])
  useEffect(() => {
    setEnStyle(lang === 'en')
  }, [lang])
  // let enFont = {}
  let enTitle = {}
  // let enTextFont = {}
  if (enStyle) {
    // enFont = { fontSize: '0.5rem' }
    enTitle = { fontSize: '1.2rem' }
    // enTextFont = { fontSize: '0.55rem' }
  }
  const { detail = {} } = state
  const {
    title, mid, created_at: createdAt, updated_at: updatedAt,
    details, types, impact, mitigation, ref, award,
    contact, declaration,
  } = detail
  return (
    <div className={styles.main}>
      <Header style={{ backgroundColor: 'rgba(0,0,0,1)' }} />
      <div className={styles.body}>
        <Breadcrumb className={styles.bread} separator=">">
          <Breadcrumb.Item>
            <Link
              style={{ color: '#333333' }}
              to={`/security/vulnerability-management/vulnerability-announcement?locale=${lang}`}
            >
              {intl.formatMessage({ id: 'Announcement.title' })}
            </Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item><span style={{ color: '#999999' }}>{title}</span></Breadcrumb.Item>
        </Breadcrumb>
        <div className={styles.content}>
          <div style={{ position: 'absolute', left: '50%', top: '45%' }}>
            <Spin size="large" spinning={loading.effects['secureModule/getDetail']} />
          </div>
          <div className={styles.title} style={enTitle}>{title}</div>
          <Divider />
          <div className={styles.subtitle}>
            {intl.formatMessage({ id: 'Detail.Identifier' })}
            {mid}
          </div>
          <div className={styles.subtitle}>
            {intl.formatMessage({ id: 'Detail.firstTime' })}
            {createdAt}
          </div>
          <div className={styles.subtitle}>
            {intl.formatMessage({ id: 'Detail.lastTime' })}
            {updatedAt}
          </div>
          <Divider />
          <div className={styles.orangeFont}>
            {`- ${intl.formatMessage({ id: 'Detail.description' })}`}
          </div>
          <Divider style={{ opacity: 0.5 }} />
          <div className={styles.text}>{details}</div>
          {types === 1 && (
            <div>
              <Divider />
              <div className={styles.orangeFont}>
                {`- ${intl.formatMessage({ id: 'Detail.affectedProducts' })}`}
              </div>
              <Divider style={{ opacity: 0.5 }} />
              {/* <div className={styles.text}>{products}</div> */}
              <ReactMarkdown
                source={mitigation}
                escapeHtml={false}
                className={styles.markdown}
              />
              <Divider />
              <div className={styles.orangeFont}>
                {`- ${intl.formatMessage({ id: 'Detail.influences' })}`}
              </div>
              <Divider style={{ opacity: 0.5 }} />
              <div className={styles.text}>{impact}</div>
              <Divider />
              {/* <div className={styles.orangeFont}>
                {`- ${intl.formatMessage({ id: 'Detail.repairPlan' })}`}
              </div>
              <Divider style={{ opacity: 0.5 }} />
              <div className={styles.text}>{mitigation}</div>
              <Divider /> */}
              <div className={styles.orangeFont}>
                {`- ${intl.formatMessage({ id: 'Detail.reference' })}`}
              </div>
              <Divider style={{ opacity: 0.5 }} />
              <div className={styles.text}>{ref}</div>
              <Divider />
              <div className={styles.orangeFont}>
                {`- ${intl.formatMessage({ id: 'Detail.thank' })}`}
              </div>
              <Divider style={{ opacity: 0.5 }} />
              <div className={styles.text}>{award}</div>
              <Divider />
              <div className={styles.orangeFont}>
                {`- ${intl.formatMessage({ id: 'Detail.contactDetails' })}`}
              </div>
              <Divider style={{ opacity: 0.5 }} />
              <div
                className={styles.text}
                dangerouslySetInnerHTML={{ __html: textToUrl(contact) }}  // eslint-disable-line
              />
              <Divider />
              <div className={styles.orangeFont}>
                {`- ${intl.formatMessage({ id: 'Detail.terms' })}`}
              </div>
              <Divider style={{ opacity: 0.5 }} />
              <div className={styles.text} style={{ marginBottom: '10vh' }}>{declaration}</div>
            </div>
          )}
        </div>
      </div>
      <Footer />
    </div>
  )
}
const mapState = state => ({
  state: state.secureModule,
  loading: state.loading,
})
export default connect(mapState)(injectIntl(Detail))
